import type { FeedbackMineItem } from '@/types/feedback'

/** Badge tone for the user-facing status string the API returns (brief AD7). */
export function statusTone(userStatus: string): 'neutral' | 'active' | 'done' {
  const s = userStatus.toLowerCase()
  if (s.startsWith('resolved')) return 'done'
  if (s.startsWith('in progress')) return 'active'
  return 'neutral'
}

export const TONE_CLASS: Record<ReturnType<typeof statusTone>, string> = {
  neutral: 'bg-muted text-muted-foreground',
  active: 'bg-amber-500/15 text-amber-700 dark:text-amber-300',
  done: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300',
}

export function kindLabel(item: Pick<FeedbackMineItem, 'type' | 'subtype'>): string {
  if (item.type === 'bug') return 'Bug'
  if (item.type === 'rating') return 'Rating'
  return item.subtype === 'new_feature' ? 'New feature' : 'Improvement'
}

export function formatReportDate(iso: string | null): string {
  if (!iso) return ''
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString(undefined, { dateStyle: 'medium' })
}

/** Bugs first (they carry a lifecycle), then everything else, newest first within each. */
export function orderForDisplay(items: FeedbackMineItem[]): FeedbackMineItem[] {
  const ts = (i: FeedbackMineItem) => (i.created_at ? Date.parse(i.created_at) : 0)
  return [...items].sort((a, b) => {
    const bugFirst = Number(b.type === 'bug') - Number(a.type === 'bug')
    return bugFirst !== 0 ? bugFirst : ts(b) - ts(a)
  })
}

/** First `max` characters of a description, with an ellipsis when cut. Empty for no text. */
export function previewText(text: string | null | undefined, max = 30): string {
  const t = (text ?? '').replace(/\s+/g, ' ').trim()
  if (!t) return ''
  return t.length <= max ? t : t.slice(0, max).trimEnd() + '...'
}
